import { Link } from "react-router-dom";
import heroImage from "../../assets/consultancy.png";

function Intellectual() {
  return (
    <>
      {/* ================= HERO ================= */}
      <section className="relative h-[80vh] flex items-center justify-center pt-24">

        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        ></div>

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* CONTENT */}
        <div className="relative z-10 text-center text-white px-6 max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-dancing-script">
            General Legal Consultancy
          </h1>

          <p className="mt-4 text-lg text-gray-200">
            
          </p>
        </div>

      </section>

      {/* ================= CONTENT ================= */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">

          <section className="py-20">

  <div className="bg-gradient-to-br from-[#0B1C39] to-[#12356B] rounded-[32px] overflow-hidden shadow-2xl">

    <div className="grid lg:grid-cols-2">

      {/* LEFT SIDE */}
      <div className="p-10 md:p-14 flex flex-col justify-center text-white relative overflow-hidden">

        {/* BACKGROUND ACCENT */}
        <div className="absolute top-0 right-0 w-72 h-72 bg-white/5 rounded-full blur-3xl"></div>

        <p className="text-blue-200 uppercase tracking-[5px] text-sm font-semibold mb-5 relative z-10">
          General Legal Consultancy
        </p>

        <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-8 relative z-10">
          When You Need <br />
          A Sharp Legal Mind <br />
          On Call.
        </h2>

        <div className="w-24 h-[3px] bg-white mb-8 relative z-10"></div>

        <p className="text-gray-200 text-lg leading-relaxed relative z-10">
          <strong>GATI & CO. ADVOCATES</strong> provides strategic legal
          advisory services for individuals, businesses, institutions,
          and investors seeking clarity, compliance, and confidence in
          decision-making. Our consultancy approach is proactive,
          practical, and tailored to help clients minimize legal risk
          while maximizing operational efficiency.
        </p>

        <p className="mt-6 text-gray-300 text-lg leading-relaxed relative z-10">
          Whether reviewing transactions, preparing legal documentation,
          or advising on complex regulatory matters, we deliver clear,
          commercially-minded guidance designed to protect your interests
          before disputes arise.
        </p>

      </div>

      {/* RIGHT SIDE */}
      <div className="bg-white p-10 md:p-14">

        <div className="space-y-6">

          {/* ITEM 1 */}
          <div className="group border border-gray-200 hover:border-[#0B1C39] rounded-2xl p-6 transition-all duration-300 hover:shadow-lg">

            <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
              Legal Opinions
            </h3>

            <p className="text-gray-600 leading-relaxed">
              Professional advisory opinions on contracts, regulatory compliance,
              transactions, and legal risk exposure.
            </p>

          </div>

          {/* ITEM 2 */}
          <div className="group border border-gray-200 hover:border-[#0B1C39] rounded-2xl p-6 transition-all duration-300 hover:shadow-lg">

            <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
              Notary Public Services
            </h3>

            <p className="text-gray-600 leading-relaxed">
              Certification of documents, sworn declarations,
              and authentication of legal instruments.
            </p>

          </div>

          {/* ITEM 3 */}
          <div className="group border border-gray-200 hover:border-[#0B1C39] rounded-2xl p-6 transition-all duration-300 hover:shadow-lg">

            <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
              Affidavits & Statutory Declarations
            </h3>

            <p className="text-gray-600 leading-relaxed">
              Drafting, commissioning, and preparation of legally compliant
              affidavits and statutory declarations.
            </p>

          </div>

          {/* ITEM 4 */}
          <div className="group border border-gray-200 hover:border-[#0B1C39] rounded-2xl p-6 transition-all duration-300 hover:shadow-lg">

            <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
              Pre-Trial Strategy
            </h3>

            <p className="text-gray-600 leading-relaxed">
              Evidence gathering, witness preparation, legal risk assessment,
              and strategic case planning before litigation begins.
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>

        </div>
      </section>

      {/* ================= NAV BUTTONS ================= */}
      <section className="py-12 px-6 bg-gray-100 border-t border-gray-200">
        <div className="max-w-7xl mx-auto flex justify-between items-center">

          {/* LEFT BUTTON */}
          <Link
            to="/services"
            className="px-6 py-3 border-2 border-[#0B3D91] text-[#0B3D91] bg-white rounded-lg font-semibold hover:bg-[#0B3D91] hover:text-white transition hover:-translate-x-1"
          >
            ← Back to practice areas
          </Link>

          {/* RIGHT BUTTON */}
          <Link
            to="/services/probate"
            className="px-6 py-3 bg-[#0B3D91] text-white rounded-lg font-semibold hover:bg-blue-800 transition hover:translate-x-1"
          >
            Next Area →
          </Link>

        </div>
      </section>
    </>
  );
}

export default Intellectual;